// @ts-nocheck
if (!customElements.get('plan-filter-calendar')) {
  // Trip mode identifiers
  const MODE = { ROUND_TRIP: 'round-trip', ONE_WAY: 'one-way' };
  // Plan service type identifiers
  const SERVICE = { PREPAID: 'prepaid', POSTPAID: 'postpaid' };
  // Custom event names
  const EVT = { CART_UPDATE: 'cart:update', DEVICE_SELECT: 'device-autocomplete:select' };
  // Status type identifiers used with setStatusMessage
  const STATUS = { LOADING: 'loading', ERROR: 'error', SUCCESS: 'success' };
  // CSS class names (without leading dot, for classList operations)
  const CLS = {
    IS_OPEN: 'is-open',
    IS_ACTIVE: 'is-active',
    IS_SELECTED: 'is-selected',
    IS_DISABLED: 'has-selection',
    HAS_SELECTION: 'has-selection',
    HAS_APPLIED: 'has-applied-dates',
    RANGE_START: 'is-range-start',
    RANGE_END: 'is-range-end',
    IN_RANGE: 'is-in-range',
    STATUS_LOADING: 'plan-filter__status--loading',
    STATUS_ERROR: 'plan-filter__status--error',
    STATUS_SUCCESS: 'plan-filter__status--success',
    FOOTER_HIDDEN: 'plan-filter__product-footer--hidden',
  };
  // Query selectors (with leading dot or bracket)
  const SEL = {
    FOOTER: '.plan-filter__product-footer',
  };

  customElements.define(
    'plan-filter-calendar',
    class PlanFilterCalendar extends HTMLElement {
      connectedCallback() {
        this.openButton = this.querySelector('[data-plan-filter-open]');
        this.display = this.querySelector('[data-plan-filter-display]');
        this.modal = this.querySelector('[data-plan-filter-modal]');
        this.applyButton = this.querySelector('[data-plan-filter-apply]');
        this.monthsContainer = this.querySelector('[data-plan-filter-months]');
        this.modeButtons = this.querySelectorAll('[data-plan-filter-mode]');
        this.closeButtons = this.querySelectorAll('[data-plan-filter-close]');
        this.navButtons = this.querySelectorAll('[data-plan-filter-nav]');
        this.modeInput = this.querySelector('[data-plan-filter-mode-input]');
        this.startInput = this.querySelector('[data-plan-filter-start-input]');
        this.endInput = this.querySelector('[data-plan-filter-end-input]');
        this.usageInput = this.querySelector('[data-plan-filter-usage-input]');
        this.findButton = this.querySelector('[data-plan-filter-find-button]');
        this.footerSelection = this.querySelector('[data-plan-filter-footer-selection]');
        this.fieldMeta = this.querySelector('[data-plan-filter-field-meta]');
        this.usageControl = this.querySelector('[data-plan-filter-usage-control]');
        this.usageToggle = this.querySelector('[data-plan-filter-usage-toggle]');
        this.usageMenu = this.querySelector('[data-plan-filter-usage-menu]');
        this.usageLabel = this.querySelector('[data-plan-filter-usage-label]');
        this.usageOptions = this.querySelectorAll('[data-plan-filter-usage-option]');
        this.scope = this.closest('.plan-filter') || this.parentElement;
        this.resultBlock = this.scope ? this.scope.querySelector('[data-plan-filter-result]') : null;
        this.recommendedDates = this.scope ? this.scope.querySelector('[data-plan-filter-recommended-dates]') : null;
        this.statusElement = this.scope ? this.scope.querySelector('[data-plan-filter-status]') : null;
        this.productContainer = this.scope
          ? this.scope.querySelector('.plan-filter__result')
          : null;
        this.productFooter = this.scope
          ? this.scope.querySelector(SEL.FOOTER)
          : null;
        this.productContainerObserver = null;
        this.onScrollCheckProductContainerVisibility =
          this.onScrollCheckProductContainerVisibility?.bind(this) ||
          this.onScrollCheckProductContainerVisibility.bind(this);
        this.deviceAutocompleteRoot = null;
        this.planFilterTitle = document.querySelector('[data-plan-filter-title]');

        if (
          !(this.openButton instanceof HTMLButtonElement) ||
          !(this.modal instanceof HTMLElement) ||
          !(this.monthsContainer instanceof HTMLElement) ||
          !(this.applyButton instanceof HTMLButtonElement)
        ) {
          return;
        }

        this.defaultMode = this.dataset.defaultMode === MODE.ONE_WAY ? MODE.ONE_WAY : MODE.ROUND_TRIP;
        this.locale = this.dataset.dateFormatLocale || 'en-CA';
        this.placeholder = this.dataset.fieldPlaceholder || '';

        this.today = this.getStartOfDay(new Date());
        this.visibleDate = new Date(this.today.getFullYear(), this.today.getMonth(), 1);

        this.appliedMode = this.defaultMode;
        this.appliedStartDate = null;
        this.appliedEndDate = null;
        this.appliedDataUsage = '';

        this.activeMode = this.appliedMode;
        this.selectedStartDate = this.appliedStartDate;
        this.selectedEndDate = this.appliedEndDate;

        this.onOpenClick = this.onOpenClick.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.onApplyClick = this.onApplyClick.bind(this);
        this.onModeClick = this.onModeClick.bind(this);
        this.onNavClick = this.onNavClick.bind(this);
        this.onCalendarClick = this.onCalendarClick.bind(this);
        this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onUsageToggleClick = this.onUsageToggleClick.bind(this);
        this.onUsageOptionClick = this.onUsageOptionClick.bind(this);
        this.onFindPlanClick = this.onFindPlanClick.bind(this);
        this.onDeviceAutocompleteSelect = this.onDeviceAutocompleteSelect.bind(this);
        this.onResizeUnderlineTitle = this.onResizeUnderlineTitle.bind(this);

        this.openButton.addEventListener('click', this.onOpenClick);
        this.applyButton.addEventListener('click', this.onApplyClick);
        if (this.findButton instanceof HTMLButtonElement) {
          this.findButton.addEventListener('click', this.onFindPlanClick);
        }
        this.modeButtons.forEach((button) => button.addEventListener('click', this.onModeClick));
        this.closeButtons.forEach((button) => button.addEventListener('click', this.onCloseClick));
        this.navButtons.forEach((button) => button.addEventListener('click', this.onNavClick));
        this.monthsContainer.addEventListener('click', this.onCalendarClick);
        document.addEventListener('keydown', this.onDocumentKeydown);
        document.addEventListener('click', this.onDocumentClick);
        if (this.usageToggle instanceof HTMLButtonElement) {
          this.usageToggle.addEventListener('click', this.onUsageToggleClick);
        }
        this.usageOptions.forEach((option) => option.addEventListener('click', this.onUsageOptionClick));

        // Ensure modal is closed on initial render.
        this.modal.hidden = true;

        this.syncHiddenInputs();
        this.updateDisplayText();
        this.updateRecommendedDates();
        this.updateDataUsageVisibility();
        this.updateDataUsageUI();
        this.updateFindButtonState();
        this.updateAppliedDateFieldState();
        this.updateDateFieldMeta();
        this.updateModeButtons();
        this.updateApplyState();
        this.updateFooterSelectionText();
        this.hideResultBlock();
        this.render();
        this.initProductFooterVisibilityTracking();
        this.initFromUrlParams();
        //this.underlineLastLine(this.planFilterTitle);
        window.addEventListener('resize', this.onResizeUnderlineTitle);
      }

      disconnectedCallback() {
        if (this.openButton instanceof HTMLButtonElement) {
          this.openButton.removeEventListener('click', this.onOpenClick);
        }
        if (this.applyButton instanceof HTMLButtonElement) {
          this.applyButton.removeEventListener('click', this.onApplyClick);
        }
        if (this.findButton instanceof HTMLButtonElement) {
          this.findButton.removeEventListener('click', this.onFindPlanClick);
        }
        if (this.monthsContainer instanceof HTMLElement) {
          this.monthsContainer.removeEventListener('click', this.onCalendarClick);
        }
        this.modeButtons.forEach((button) => button.removeEventListener('click', this.onModeClick));
        this.closeButtons.forEach((button) => button.removeEventListener('click', this.onCloseClick));
        this.navButtons.forEach((button) => button.removeEventListener('click', this.onNavClick));
        document.removeEventListener('keydown', this.onDocumentKeydown);
        document.removeEventListener('click', this.onDocumentClick);
        if (this.usageToggle instanceof HTMLButtonElement) {
          this.usageToggle.removeEventListener('click', this.onUsageToggleClick);
        }
        this.usageOptions.forEach((option) => option.removeEventListener('click', this.onUsageOptionClick));

        if (this.deviceAutocompleteRoot instanceof HTMLElement) {
          this.deviceAutocompleteRoot.removeEventListener(
            EVT.DEVICE_SELECT,
            this.onDeviceAutocompleteSelect
          );
        }

        if (this.productContainerObserver) {
          this.productContainerObserver.disconnect();
          this.productContainerObserver = null;
        }

        if (typeof window !== 'undefined') {
          window.removeEventListener('scroll', this.onScrollCheckProductContainerVisibility);
          window.removeEventListener('resize', this.onScrollCheckProductContainerVisibility);
          window.removeEventListener('resize', this.onResizeUnderlineTitle);
        }
      }

      onResizeUnderlineTitle() {
        this.underlineLastLine(this.planFilterTitle);
      }

      underlineLastLine(el) {
        if (!(el instanceof HTMLElement)) return;

        if (!el.dataset.originalText) {
          const textNode = el.firstChild;
          if (!textNode || textNode.nodeType !== Node.TEXT_NODE) return;
          el.dataset.originalText = textNode.textContent;
        }

        el.innerHTML = el.dataset.originalText;

        const textNode = el.firstChild;
        if (!textNode || textNode.nodeType !== Node.TEXT_NODE) return;

        const text = textNode.textContent;
        const range = document.createRange();

        const lines = [];
        let currentLine = "";
        let lastTop = null;

        for (let i = 0; i < text.length; i++) {
          range.setStart(textNode, i);
          range.setEnd(textNode, i + 1);

          const rect = range.getBoundingClientRect();
          if (!rect.height) continue;

          if (lastTop === null) {
            lastTop = rect.top;
          }

          // новий рядок
          if (Math.abs(rect.top - lastTop) > 1) {
            lines.push(currentLine);
            currentLine = "";
            lastTop = rect.top;
          }

          currentLine += text[i];
        }

        if (currentLine) {
          lines.push(currentLine);
        }

        // очищаємо елемент
        el.innerHTML = "";

        lines.forEach((line, index) => {
          const span = document.createElement("span");
          span.textContent = line.trim();

          // if (index === lines.length - 1) {
          //   span.classList.add("plan-filter__title-highlight");
          // }

          el.appendChild(span);

          if (index !== lines.length - 1) {
            el.appendChild(document.createElement("br"));
          }
        });
      }

      initFromUrlParams() {
        const params = new URLSearchParams(window.location.search);
        const startRaw = params.get('plan_filter_start');
        const endRaw = params.get('plan_filter_end');
        const modeRaw = params.get('plan_filter_mode');
        const usage = params.get('plan_filter_usage');

        if (!startRaw) return;

        const start = new Date(`${startRaw}T00:00:00`);
        if (isNaN(start.getTime())) return;

        const mode = modeRaw === MODE.ONE_WAY ? MODE.ONE_WAY : MODE.ROUND_TRIP;
        this.appliedMode = mode;
        this.activeMode = mode;
        if (this.modeInput instanceof HTMLInputElement) {
          this.modeInput.value = mode;
        }

        this.appliedStartDate = start;
        this.selectedStartDate = start;
        if (this.startInput instanceof HTMLInputElement) {
          this.startInput.value = startRaw;
        }

        if (mode === MODE.ROUND_TRIP && endRaw) {
          const end = new Date(`${endRaw}T00:00:00`);
          if (!isNaN(end.getTime())) {
            this.appliedEndDate = end;
            this.selectedEndDate = end;
            if (this.endInput instanceof HTMLInputElement) {
              this.endInput.value = endRaw;
            }
          }
        }

        if (usage) {
          this.appliedDataUsage = usage;
          if (this.usageInput instanceof HTMLInputElement) {
            this.usageInput.value = usage;
          }
        }

        this.updateModeButtons();
        this.updateDisplayText();
        this.updateRecommendedDates();
        this.updateDateFieldMeta();
        this.updateAppliedDateFieldState();
        this.updateDataUsageVisibility();
        this.updateDataUsageUI();
        this.updateFindButtonState();
        this.updateShortTermBanner();
        this.syncHiddenInputs();
      }

      onOpenClick() {
        if (!(this.modal instanceof HTMLElement)) return;

        this.activeMode = this.appliedMode;
        this.selectedStartDate = this.appliedStartDate ? new Date(this.appliedStartDate) : null;
        this.selectedEndDate = this.appliedEndDate ? new Date(this.appliedEndDate) : null;

        const anchorDate = this.selectedStartDate || this.today;
        this.visibleDate = new Date(anchorDate.getFullYear(), anchorDate.getMonth(), 1);

        this.modal.hidden = false;
        document.body.style.overflow = 'hidden';

        this.updateModeButtons();
        this.updateApplyState();
        this.updateFooterSelectionText();
        this.render();
      }

      onCloseClick() {
        this.closeModal();
      }

      onApplyClick() {
        if (!this.canApply()) return;

        this.appliedMode = this.activeMode;
        this.appliedStartDate = this.selectedStartDate ? new Date(this.selectedStartDate) : null;
        this.appliedEndDate = this.selectedEndDate ? new Date(this.selectedEndDate) : null;

        this.syncHiddenInputs();
        this.updateDisplayText();
        this.updateRecommendedDates();
        this.updateDataUsageVisibility();
        this.updateDataUsageUI();
        this.updateFindButtonState();
        this.updateAppliedDateFieldState();
        this.updateDateFieldMeta();
        this.updateShortTermBanner();
        this.hideResultBlock();
        this.closeModal();
      }

      async onFindPlanClick(event) {
        if (!(event instanceof Event)) return;
        event.preventDefault();
        await this.handleFindPlan();
      }

      async handleFindPlan() {
        if (!(this.findButton instanceof HTMLButtonElement)) return;
        if (this.findButton.disabled) return;

        const mode = this.appliedMode;
        const serviceType = mode === MODE.ONE_WAY ? SERVICE.POSTPAID : SERVICE.PREPAID;
        const hasDates =
          this.appliedStartDate instanceof Date &&
          (mode === MODE.ONE_WAY || (mode === MODE.ROUND_TRIP && this.appliedEndDate instanceof Date));

        if (!hasDates) {
          this.setStatusMessage('Please select your dates first.', STATUS.ERROR);
          return;
        }

        const days =
          mode === MODE.ONE_WAY || !(this.appliedEndDate instanceof Date)
            ? 1
            : this.getDaysBetween(this.appliedStartDate, this.appliedEndDate);
        if (this.dataset.planResultsUrl) {
          const shortStayThreshold = Number(this.dataset.shortTermThreshold) || 90;
          if (mode === MODE.ROUND_TRIP && days < shortStayThreshold && this.dataset.shortTermUrl) {
            window.location.assign(this.dataset.shortTermUrl);
            return;
          }
          const resultsUrl = new URL(this.dataset.planResultsUrl, window.location.origin);
          resultsUrl.searchParams.set('plan_filter_start', this.appliedStartDate.toLocaleDateString('sv-SE'));
          resultsUrl.searchParams.set('plan_filter_mode', mode);
          if (mode === MODE.ROUND_TRIP && this.appliedEndDate instanceof Date) {
            resultsUrl.searchParams.set('plan_filter_end', this.appliedEndDate.toLocaleDateString('sv-SE'));
          }
          if (this.appliedDataUsage) resultsUrl.searchParams.set('plan_filter_usage', this.appliedDataUsage);
          window.location.assign(resultsUrl.href);
          return;
        }

        const usageType = this.appliedDataUsage || null;

        this.setStatusMessage('Searching for the best plan\u2026', STATUS.LOADING);
        this.setFindButtonLoading(true);

        try {
          const products = await this.fetchMatchingPlan({
            serviceType,
            days,
            usageType
          });

          if (!products || !products.length) {
            this.setStatusMessage('No matching plan found. Please adjust your dates or data usage.', STATUS.ERROR);
            this.hideResultBlock();
            return;
          }

          const selection = products[0];
          const productUrl = new URL(`/products/${selection.handle}`, window.location.origin);

          if (this.appliedStartDate instanceof Date) {
            console.log('this.appliedStartDate', this.appliedStartDate)
            productUrl.searchParams.set('plan_filter_start', this.appliedStartDate.toLocaleDateString('sv-SE'));
          }
          if (this.appliedMode === MODE.ROUND_TRIP && this.appliedEndDate instanceof Date) {
            productUrl.searchParams.set('plan_filter_end', this.appliedEndDate.toLocaleDateString('sv-SE'));
          }
          productUrl.searchParams.set('plan_filter_mode', this.appliedMode);
          if (usageType) {
            productUrl.searchParams.set('plan_filter_usage', usageType);
          }

          window.location.assign(productUrl.toString());
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Plan filter Storefront API error', error);
          this.setStatusMessage('Something went wrong while searching for plans. Please try again.', STATUS.ERROR);
          this.hideResultBlock();
        } finally {
          this.setFindButtonLoading(false);
        }
      }

      onUsageToggleClick(event) {
        event.preventDefault();
        if (!(this.usageControl instanceof HTMLElement) || this.usageControl.hidden) return;
        const isOpen = this.usageControl.classList.contains(CLS.IS_OPEN);
        this.setUsageMenuOpen(!isOpen);
      }

      onUsageOptionClick(event) {
        const target = event.currentTarget;
        if (!(target instanceof HTMLButtonElement)) return;
        const value = target.dataset.planFilterUsageOption || '';
        if (!value) return;
        this.appliedDataUsage = value;
        this.syncHiddenInputs();
        this.updateDataUsageUI();
        this.updateFindButtonState();
        this.setUsageMenuOpen(false);
      }

      onModeClick(event) {
        const target = event.currentTarget;
        if (!(target instanceof HTMLButtonElement)) return;

        const mode = target.dataset.planFilterMode === MODE.ONE_WAY ? MODE.ONE_WAY : MODE.ROUND_TRIP;
        if (mode === this.activeMode) return;

        this.activeMode = mode;

        if (mode === MODE.ONE_WAY) {
          this.selectedEndDate = null;
        }

        this.updateModeButtons();
        this.updateApplyState();
        this.updateFooterSelectionText();
        this.render();
      }

      onNavClick(event) {
        const target = event.currentTarget;
        if (!(target instanceof HTMLButtonElement)) return;

        const direction = target.dataset.planFilterNav === 'prev' ? -1 : 1;
        this.visibleDate = new Date(this.visibleDate.getFullYear(), this.visibleDate.getMonth() + direction, 1);
        this.render();
      }

      onCalendarClick(event) {
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;

        const button = target.closest('[data-plan-filter-day]');
        if (!(button instanceof HTMLButtonElement)) return;
        if (button.disabled) return;

        const isoDate = button.dataset.planFilterDay;
        if (!isoDate) return;

        const selectedDate = this.parseIsoDate(isoDate);
        if (!selectedDate) return;

        if (this.activeMode === MODE.ONE_WAY) {
          this.selectedStartDate = selectedDate;
          this.selectedEndDate = null;
        } else if (!(this.selectedStartDate instanceof Date) || this.selectedEndDate instanceof Date) {
          this.selectedStartDate = selectedDate;
          this.selectedEndDate = null;
        } else if (selectedDate.getTime() < this.selectedStartDate.getTime()) {
          this.selectedEndDate = this.selectedStartDate;
          this.selectedStartDate = selectedDate;
        } else {
          this.selectedEndDate = selectedDate;
        }

        this.updateApplyState();
        this.updateFooterSelectionText();
        this.render();
      }

      onDocumentKeydown(event) {
        if (!(event instanceof KeyboardEvent)) return;
        if (event.key !== 'Escape') return;
        if (this.usageControl instanceof HTMLElement && this.usageControl.classList.contains(CLS.IS_OPEN)) {
          this.setUsageMenuOpen(false);
          return;
        }
        if (!(this.modal instanceof HTMLElement) || this.modal.hidden) return;
        this.closeModal();
      }

      onDocumentClick(event) {
        if (!(this.usageControl instanceof HTMLElement)) return;
        if (!this.usageControl.classList.contains(CLS.IS_OPEN)) return;
        if (!(event.target instanceof Node)) return;
        if (this.usageControl.contains(event.target)) return;
      }

      closeModal() {
        if (!(this.modal instanceof HTMLElement)) return;
        this.modal.hidden = true;
        document.body.style.overflow = '';
      }

      canApply() {
        if (!(this.selectedStartDate instanceof Date)) return false;
        if (this.activeMode === MODE.ROUND_TRIP && !(this.selectedEndDate instanceof Date)) return false;
        return true;
      }

      updateApplyState() {
        if (!(this.applyButton instanceof HTMLButtonElement)) return;
        this.applyButton.disabled = !this.canApply();
      }

      updateModeButtons() {
        this.modeButtons.forEach((button) => {
          const mode = button.dataset.planFilterMode === MODE.ONE_WAY ? MODE.ONE_WAY : MODE.ROUND_TRIP;
          const isActive = mode === this.activeMode;
          button.classList.toggle(CLS.IS_ACTIVE, isActive);
          button.setAttribute('aria-selected', String(isActive));
        });
      }

      updateDisplayText() {
        if (!(this.display instanceof HTMLElement)) return;

        if (!(this.appliedStartDate instanceof Date)) {
          this.display.textContent = this.placeholder;
          return;
        }

        if (this.appliedMode === MODE.ONE_WAY) {
          this.display.textContent = this.formatForDisplay(this.appliedStartDate);
          return;
        }

        if (this.appliedEndDate instanceof Date) {
          this.display.textContent = this.formatDateRangeForDisplay(this.appliedStartDate, this.appliedEndDate);
          return;
        }

        this.display.textContent = this.formatForDisplay(this.appliedStartDate);
      }

      updateRecommendedDates() {
        if (!(this.recommendedDates instanceof HTMLElement)) return;
        console.log('recommendedDates >>>', this.appliedStartDate, this.appliedStartDate instanceof Date)

        if (!(this.appliedStartDate instanceof Date)) {
          this.recommendedDates.textContent = '';
          return;
        }

        if (this.appliedMode === MODE.ONE_WAY) {
          this.recommendedDates.textContent = this.formatForDisplay(this.appliedStartDate);
          return;
        }

        if (this.appliedEndDate instanceof Date) {
          this.recommendedDates.textContent = this.formatDateRangeForDisplay(this.appliedStartDate, this.appliedEndDate);
          return;
        }

        this.recommendedDates.textContent = this.formatForDisplay(this.appliedStartDate);
      }
updateShortTermBanner() {
  const banner = this.scope
    ? this.scope.querySelector('[data-plan-filter-recommendation]')
    : null;
  if (!(banner instanceof HTMLElement)) return;

  const threshold = parseInt(this.dataset.shortTermThreshold || '90', 10);

  // One Way mode — always show banner (1 day, short stay)
  if (this.appliedMode === 'one-way' && this.appliedStartDate instanceof Date) {
    banner.hidden = false;
    return;
  }

  // Round Trip mode — show only if days < threshold
  if (
    this.appliedMode === 'round-trip' &&
    this.appliedStartDate instanceof Date &&
    this.appliedEndDate instanceof Date
  ) {
    const days = this.getDaysBetween(this.appliedStartDate, this.appliedEndDate);
    banner.hidden = days >= threshold;
    return;
  }

  // No dates selected — hide
  banner.hidden = true;
}

      updateFindButtonState() {
        if (!(this.findButton instanceof HTMLButtonElement)) return;
        const hasStart = this.appliedStartDate instanceof Date;
        const hasEnd = this.appliedEndDate instanceof Date;
        const hasValidDataUsage = !this.shouldShowDataUsageSelector() || Boolean(this.appliedDataUsage);
        const isEnabled = (this.appliedMode === MODE.ONE_WAY ? hasStart : hasStart && hasEnd) && hasValidDataUsage;
        this.findButton.disabled = !isEnabled;
      }

      updateAppliedDateFieldState() {
        const hasAppliedSelection =
          this.appliedMode === MODE.ONE_WAY
            ? this.appliedStartDate instanceof Date
            : this.appliedStartDate instanceof Date && this.appliedEndDate instanceof Date;
        this.classList.toggle(CLS.HAS_APPLIED, hasAppliedSelection);
      }

      updateDateFieldMeta() {
        if (!(this.fieldMeta instanceof HTMLElement)) return;

        if (this.appliedMode === MODE.ONE_WAY && this.appliedStartDate instanceof Date) {
          this.fieldMeta.hidden = false;
          this.fieldMeta.textContent = 'One Way';
          return;
        }

        if (this.appliedMode === MODE.ROUND_TRIP && this.appliedStartDate instanceof Date && this.appliedEndDate instanceof Date) {
          const days = this.getDaysBetween(this.appliedStartDate, this.appliedEndDate);

          console.log('days', days)
          this.fieldMeta.hidden = false;
          this.fieldMeta.textContent = `${days} ${days === 1 ? 'Day' : 'Days'}`;
          return;
        }

        this.fieldMeta.hidden = true;
        this.fieldMeta.textContent = '';
      }

      shouldShowDataUsageSelector() {
        if (this.appliedMode === MODE.ONE_WAY) {
          return this.appliedStartDate instanceof Date;
        }

        if (this.appliedMode === MODE.ROUND_TRIP) {
          if (!(this.appliedStartDate instanceof Date) || !(this.appliedEndDate instanceof Date)) return false;

          const params = new URLSearchParams(window.location.search);
          const usage = params.get('plan_filter_usage');

          if (this.getDaysBetween(this.appliedStartDate, this.appliedEndDate) > 90 && usage) {
            return true;
          } else {
            return false;
          }

        }

        return false;
      }

      updateDataUsageVisibility() {
        const shouldShow = this.shouldShowDataUsageSelector();
        if (this.usageControl instanceof HTMLElement) {
          this.usageControl.hidden = !shouldShow;
        }
        if (shouldShow) {
          // Open the menu only when no value has been selected yet
          this.setUsageMenuOpen(!this.appliedDataUsage);
        } else {
          this.appliedDataUsage = '';
          this.setUsageMenuOpen(false);
          this.syncHiddenInputs();
        }
      }

      updateDataUsageUI() {
        const selectedLabel = this.appliedDataUsage || 'Data Usage';
        if (this.usageControl instanceof HTMLElement) {
          this.usageControl.classList.toggle(CLS.HAS_SELECTION, Boolean(this.appliedDataUsage));
        }
        if (this.usageLabel instanceof HTMLElement) {
          this.usageLabel.textContent = selectedLabel;
        }
        this.usageOptions.forEach((option) => {
          const value = option.dataset.planFilterUsageOption || '';
          const isSelected = value === this.appliedDataUsage;
          option.classList.toggle(CLS.IS_SELECTED, isSelected);
          option.setAttribute('aria-selected', String(isSelected));
        });
      }

      setUsageMenuOpen(isOpen) {
        if (!(this.usageControl instanceof HTMLElement)) return;
        this.usageControl.classList.toggle(CLS.IS_OPEN, isOpen);
        if (this.usageMenu instanceof HTMLElement) {
          this.usageMenu.hidden = !isOpen;
        }
        if (this.usageToggle instanceof HTMLButtonElement) {
          this.usageToggle.setAttribute('aria-expanded', String(isOpen));
        }
      }

      initProductFooterVisibilityTracking() {
        if (typeof window === 'undefined' || !(this.productContainer instanceof HTMLElement)) {
          return;
        }

        const updateVisibility = (isVisible) => {
          const footer =
            (this.scope && this.scope.querySelector(SEL.FOOTER)) || this.productFooter;
          if (!(footer instanceof HTMLElement)) {
            return;
          }
          this.productFooter = footer;
          footer.classList.toggle(CLS.FOOTER_HIDDEN, !isVisible);
        };

        if ('IntersectionObserver' in window) {
          if (this.productContainerObserver) {
            this.productContainerObserver.disconnect();
          }
          this.productContainerObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.target === this.productContainer) {
                  updateVisibility(entry.isIntersecting);
                }
              });
            },
            {
              threshold: 0
            }
          );

          this.productContainerObserver.observe(this.productContainer);
          updateVisibility(this.productContainer.getBoundingClientRect().bottom > 0);
        } else {
          this.onScrollCheckProductContainerVisibility();
          window.addEventListener('scroll', this.onScrollCheckProductContainerVisibility, {
            passive: true
          });
          window.addEventListener('resize', this.onScrollCheckProductContainerVisibility);
        }
      }

      onScrollCheckProductContainerVisibility() {
        if (typeof window === 'undefined' || !(this.productContainer instanceof HTMLElement)) {
          return;
        }

        const rect = this.productContainer.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        const isVisible = rect.bottom > 0 && rect.top < viewportHeight;

        const footer =
          (this.scope && this.scope.querySelector(SEL.FOOTER)) || this.productFooter;
        if (!(footer instanceof HTMLElement)) {
          return;
        }
        this.productFooter = footer;
        footer.classList.toggle(CLS.FOOTER_HIDDEN, !isVisible);
      }

      hideResultBlock() {
        if (!(this.resultBlock instanceof HTMLElement)) return;
        this.resultBlock.hidden = true;
      }


      updateFooterSelectionText() {
        if (!(this.footerSelection instanceof HTMLElement)) return;

        if (!(this.selectedStartDate instanceof Date)) {
          this.footerSelection.textContent = 'Select your arrival date in Canada';
          return;
        }

        if (this.activeMode === MODE.ONE_WAY) {
          this.footerSelection.innerHTML = `<span>Arrival date in Canada: <strong>${this.formatForDisplay(this.selectedStartDate)}</strong></span>`;
          return;
        }

        if (this.selectedEndDate instanceof Date) {
          this.footerSelection.innerHTML = `<span>Arrival date in Canada: <strong>${this.formatDateRangeForDisplay(
            this.selectedStartDate,
            this.selectedEndDate
          )}</strong></span>`;
          return;
        }

        this.footerSelection.innerHTML = `<span>Arrival date in Canada: <strong>${this.formatForDisplay(this.selectedStartDate)}</strong></span>`;
      }

      syncHiddenInputs() {
        if (this.modeInput instanceof HTMLInputElement) {
          this.modeInput.value = this.appliedMode;
        }

        if (this.startInput instanceof HTMLInputElement) {
          this.startInput.value =
            this.appliedStartDate instanceof Date ? this.formatToIsoDate(this.appliedStartDate) : '';
        }

        if (this.endInput instanceof HTMLInputElement) {
          this.endInput.value =
            this.appliedMode === MODE.ROUND_TRIP && this.appliedEndDate instanceof Date
              ? this.formatToIsoDate(this.appliedEndDate)
              : '';
        }
        if (this.usageInput instanceof HTMLInputElement) {
          this.usageInput.value = this.appliedDataUsage || '';
        }
      }


      onDeviceAutocompleteSelect(event) {
        if (!event || !event.detail) return;
        const displayName = typeof event.detail.displayName === 'string' ? event.detail.displayName : '';
        const brand = typeof event.detail.brand === 'string' ? event.detail.brand : '';

        const parts = [];
        if (displayName.trim()) {
          parts.push(displayName.trim());
        }
        if (brand.trim()) {
          parts.push(brand.trim());
        }
      }

      isMobileViewport() {
        if (typeof window === 'undefined') {
          return false;
        }
        if (typeof window.matchMedia === 'function') {
          return window.matchMedia('(max-width: 767px)').matches;
        }
        return window.innerWidth <= 767;
      }

      render() {
        if (!(this.monthsContainer instanceof HTMLElement)) return;

        const firstMonthDate = new Date(this.visibleDate.getFullYear(), this.visibleDate.getMonth(), 1);
        this.monthsContainer.innerHTML = '';
        this.monthsContainer.appendChild(this.renderMonth(firstMonthDate));
        if (!this.isMobileViewport()) {
          const secondMonthDate = new Date(this.visibleDate.getFullYear(), this.visibleDate.getMonth() + 1, 1);
          this.monthsContainer.appendChild(this.renderMonth(secondMonthDate));
        }
      }

      renderMonth(monthDate) {
        const monthWrap = document.createElement('div');
        monthWrap.className = 'plan-filter-calendar__month';

        const monthTitle = document.createElement('p');
        monthTitle.className = 'plan-filter-calendar__month-title';
        monthTitle.textContent = monthDate.toLocaleDateString(this.locale, {
          month: 'long',
          year: 'numeric'
        });
        monthWrap.appendChild(monthTitle);

        const weekdays = document.createElement('div');
        weekdays.className = 'plan-filter-calendar__weekdays';
        ['S', 'M', 'T', 'W', 'T', 'F', 'S'].forEach((dayName) => {
          const dayNode = document.createElement('span');
          dayNode.className = 'plan-filter-calendar__weekday';
          dayNode.textContent = dayName;
          weekdays.appendChild(dayNode);
        });
        monthWrap.appendChild(weekdays);

        const grid = document.createElement('div');
        grid.className = 'plan-filter-calendar__grid';

        const year = monthDate.getFullYear();
        const month = monthDate.getMonth();
        const firstDay = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        for (let i = 0; i < firstDay; i += 1) {
          const empty = document.createElement('span');
          empty.className = 'plan-filter-calendar__empty';
          grid.appendChild(empty);
        }

        for (let day = 1; day <= daysInMonth; day += 1) {
          const dayDate = new Date(year, month, day);
          const dayButton = document.createElement('button');
          dayButton.type = 'button';
          dayButton.className = 'plan-filter-calendar__day';
          dayButton.dataset.planFilterDay = this.formatToIsoDate(dayDate);
          dayButton.textContent = String(day);
          const isPastDay = dayDate.getTime() < this.today.getTime();
          dayButton.disabled = isPastDay;
          dayButton.setAttribute('aria-disabled', String(isPastDay));

          const isSingle = this.activeMode === MODE.ONE_WAY && this.isSameDate(dayDate, this.selectedStartDate);
          const isRangeStart = this.activeMode === MODE.ROUND_TRIP && this.isSameDate(dayDate, this.selectedStartDate);
          const isRangeEnd = this.activeMode === MODE.ROUND_TRIP && this.isSameDate(dayDate, this.selectedEndDate);
          const isInRange =
            this.activeMode === MODE.ROUND_TRIP &&
            this.selectedStartDate instanceof Date &&
            this.selectedEndDate instanceof Date &&
            dayDate.getTime() > this.selectedStartDate.getTime() &&
            dayDate.getTime() < this.selectedEndDate.getTime();

          dayButton.classList.toggle(CLS.IS_SELECTED, isSingle);
          dayButton.classList.toggle(CLS.RANGE_START, isRangeStart);
          dayButton.classList.toggle(CLS.RANGE_END, isRangeEnd);
          dayButton.classList.toggle(CLS.IN_RANGE, isInRange);

          grid.appendChild(dayButton);
        }

        monthWrap.appendChild(grid);
        return monthWrap;
      }

      formatForDisplay(date) {
        const startDate = date.toLocaleDateString(this.locale, {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });


        return `${startDate}`
      }

      formatMonthDay(date) {
        return date.toLocaleDateString(this.locale, {
          month: 'short',
          day: 'numeric'
        });
      }

      formatDateRangeForDisplay(startDate, endDate) {
        if (startDate.getFullYear() === endDate.getFullYear()) {
          return `${this.formatMonthDay(startDate)} \u2192 ${this.formatMonthDay(endDate)}, ${endDate.getFullYear()}`;
        }
        return `${this.formatForDisplay(startDate)} \u2192 ${this.formatForDisplay(endDate)}`;
      }

      getDaysBetween(startDate, endDate) {
        const start = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        const end = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

        const dayMs = 24 * 60 * 60 * 1000;
        return Math.max(1, Math.round((end - start) / dayMs) + 1);
      }

      formatToIsoDate(date) {
        const year = String(date.getFullYear());
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

      parseIsoDate(value) {
        const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!match) return null;

        const year = Number(match[1]);
        const month = Number(match[2]) - 1;
        const day = Number(match[3]);
        const parsed = new Date(year, month, day);

        if (
          parsed.getFullYear() !== year ||
          parsed.getMonth() !== month ||
          parsed.getDate() !== day
        ) {
          return null;
        }

        return parsed;
      }

      getStartOfDay(date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
      }

      isSameDate(a, b) {
        if (!(a instanceof Date) || !(b instanceof Date)) return false;
        return (
          a.getFullYear() === b.getFullYear() &&
          a.getMonth() === b.getMonth() &&
          a.getDate() === b.getDate()
        );
      }

      setStatusMessage(message, type) {
        if (!(this.statusElement instanceof HTMLElement)) return;

        this.statusElement.hidden = !message;
        this.statusElement.textContent = type === STATUS.ERROR ? message || '' : '';

        this.statusElement.classList.remove(
          CLS.STATUS_LOADING,
          CLS.STATUS_ERROR,
          CLS.STATUS_SUCCESS
        );

        if (!message) return;

        if (type === STATUS.LOADING) {
          this.statusElement.classList.add(CLS.STATUS_LOADING);
        } else if (type === STATUS.ERROR) {
          this.statusElement.classList.add(CLS.STATUS_ERROR);
        } else if (type === STATUS.SUCCESS) {
          this.statusElement.classList.add(CLS.STATUS_SUCCESS);
        }
      }

      setFindButtonLoading(isLoading) {
        if (!(this.findButton instanceof HTMLButtonElement)) return;
        if (isLoading) {
          this.findButton.dataset.originalLabel = this.findButton.textContent || '';
          this.findButton.textContent = 'Searching\u2026';
          this.findButton.disabled = true;
        } else {
          const originalLabel = this.findButton.dataset.originalLabel;
          if (originalLabel) {
            this.findButton.textContent = originalLabel;
          }
          this.updateFindButtonState();
        }
      }

      async fetchMatchingPlan({ serviceType, days, usageType }) {
        const shopOrigin = window.location.origin;
        const apiVersion = '2026-01';
        const endpoint = `${shopOrigin}/api/${apiVersion}/graphql.json`;
        const accessToken = 'b5ed3cd07556934b2fb38908febd0503';

        const queryString = serviceType === SERVICE.PREPAID && days >= 91 ? '' : `product_type:${serviceType}`;

        const graphQuery = `
          query FindPlans($query: String!, $first: Int!) {
            products(first: $first, query: $query) {
              edges {
                node {
                  id
                  title
                  handle
                  metafields(identifiers: [
                    { namespace: "custom", key: "min_days_amount" },
                    { namespace: "custom", key: "max_days_amount" },
                    { namespace: "custom", key: "usage_data_type" },
                  ]) {
                    namespace
                    key
                    value
                  }
                }
              }
            }
          }
        `;

        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Shopify-Storefront-Access-Token': accessToken
          },
          body: JSON.stringify({
            query: graphQuery,
            variables: {
              query: queryString,
              first: 50
            }
          })
        });

        if (!response.ok) {
          throw new Error(`Storefront API HTTP error: ${response.status}`);
        }

        const payload = await response.json();

        if (payload.errors) {
          throw new Error(`Storefront API GraphQL error: ${JSON.stringify(payload.errors)}`);
        }

        const edges = payload?.data?.products?.edges || [];
        let products = edges.map((edge) => edge.node);

        if (serviceType === SERVICE.PREPAID && Number.isFinite(days)) {
          products = products.filter((product) => {
            const min = this.getNumericMetafield(product, 'custom', 'min_days_amount');
            const max = this.getNumericMetafield(product, 'custom', 'max_days_amount');

            if (Number.isFinite(min) && Number.isFinite(max)) {
              return days >= min && days <= max;
            }
            if (Number.isFinite(min) && !Number.isFinite(max) && days >= 91) {
              return days >= min;
            }
            return false;
          });
        }

        if (usageType) {
          const normalizedUsage = String(usageType).toLowerCase();
          products = products.filter((product) => {
            const value = this.getStringMetafield(product, 'custom', 'usage_data_type');
            if (!value) return true;
            return value.toLowerCase() === normalizedUsage;
          });
        }

        if (!products.length) {
          return [];
        }

        return products;
      }

      getNumericMetafield(product, namespace, key) {
        if (!product || !Array.isArray(product.metafields)) return Number.NaN;
        const metafield = product.metafields.find(
          (item) => item && item.namespace === namespace && item.key === key
        );
        if (!metafield || typeof metafield.value !== 'string') return Number.NaN;
        const parsed = Number(metafield.value);
        if (!Number.isFinite(parsed)) return Number.NaN;
        return parsed;
      }

      getStringMetafield(product, namespace, key) {
        if (!product || !Array.isArray(product.metafields)) return '';
        const metafield = product.metafields.find(
          (item) => item && item.namespace === namespace && item.key === key
        );
        if (!metafield || typeof metafield.value !== 'string') return '';
        return metafield.value;
      }

    }
  );
}



